import { render, staticRenderFns } from "./PlanTooltip.vue?vue&type=template&id=1fb7308e&scoped=true"
import script from "./PlanTooltip.vue?vue&type=script&lang=ts"
export * from "./PlanTooltip.vue?vue&type=script&lang=ts"
import style0 from "./PlanTooltip.vue?vue&type=style&index=0&id=1fb7308e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb7308e",
  null
  
)

export default component.exports